import { prettyPrintJson } from '@/utility';
import {
  type IntegratorInstance,
  type IntegratorInitialResolve,
  type IntegratorResponseData,
  type Token
} from '@/types';
import { useAuthToken } from '@/composables/useAuthToken';

let instance: IntegratorInstance;
let initializationResolve: IntegratorInitialResolve;
let existingAuthToken: Token;

export default {
  init() {
    this.setInstance();
    this.setListeners();

    return new Promise((resolve) => {
      initializationResolve = resolve;

      instance?.sendMessage('Slave.Init');
    });
  },

  setInstance() {
    instance = {
      sendMessage: (message: string) => {
        try {
          window.WebAppListener.sendMessage(
            JSON.stringify({
              action: message
            })
          );
        } catch (err) {
          console.error(`Error sending message ${message} to android webview`, err);
        }
      }
    };
  },

  setListeners() {
    window.onParentMessage = (message: string, payload: { data: IntegratorResponseData }) => {
      console.log(
        `Incoming message from native integrator: ${message}, ${prettyPrintJson(payload)}`
      );

      if (message === 'Slave.Load') {
        initializationResolve(payload.data);
      } else if (message === 'User.AuthorizationChanged') {
        const { sevenToken, userId } = useAuthToken();

        if (existingAuthToken !== payload.data.auth.token) {
          existingAuthToken = payload.data.auth.token;

          if (payload.data.auth.user.id) {
            userId.value = payload.data.auth.user.id;
          }
          sevenToken.value = payload.data.auth.token;
        }
      }
    };
  },

  notifyAppLoaded() {
    instance?.sendMessage('Slave.Loaded');
  }
};
